import { render, staticRenderFns } from "./unauth-layout.vue?vue&type=template&id=47c0e934&scoped=true&"
import script from "./unauth-layout.vue?vue&type=script&lang=js&"
export * from "./unauth-layout.vue?vue&type=script&lang=js&"
import style0 from "./unauth-layout.vue?vue&type=style&index=0&id=47c0e934&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c0e934",
  null
  
)

export default component.exports